var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-page"},[_c('ul',_vm._l((_vm.urls),function(url){return _c('router-link',{key:url.link,attrs:{"tag":"li","to":'/'+_vm.$root.site+'/'+url.link}},[_vm._v(_vm._s(url.text))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }